import { render, staticRenderFns } from "./DVR.vue?vue&type=template&id=2d1e2d3b&scoped=true&"
import script from "./DVR.vue?vue&type=script&lang=js&"
export * from "./DVR.vue?vue&type=script&lang=js&"
import style0 from "./DVR.vue?vue&type=style&index=0&id=2d1e2d3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1e2d3b",
  null
  
)

export default component.exports